var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.923.923a.923.923 0 0 0-1.846 0v12.54L6.499 8.887a.923.923 0 1 0-1.306 1.305l6.154 6.154a.923.923 0 0 0 1.306 0l6.154-6.154A.923.923 0 0 0 17.5 8.886l-4.578 4.578z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.846 15.692a.923.923 0 1 0-1.846 0v4.923A3.385 3.385 0 0 0 3.385 24h17.23A3.385 3.385 0 0 0 24 20.615v-4.923a.923.923 0 0 0-1.846 0v4.923a1.54 1.54 0 0 1-1.539 1.539H3.385a1.54 1.54 0 0 1-1.539-1.539z"
  })));
};
export default SvgDownload;